export default "__VITE_ASSET___GIzDOjk__"